module.exports = __webpack_public_path__ + "img/treebu_logo_crop.81045451.png";